.tab {
  background: transparent;
  border-width: 0;
  cursor: pointer;
  flex-shrink: 0;
  overflow: hidden;
  transition: all 250ms;
  text-decoration: none;
  width: var(--width);
}

.tab:hover,
.tab:focus-visible {
  background-color: var(--colors-grays-hover);
  outline: none;
}

.tab__selected {
  pointer-events: none;
}

.tab__direction__vertical {
  margin-right: 16px;
  padding: 12px 0;
  text-align: left;
}

.tab__direction__vertical .tabLabel {
  padding: 0 16px;
}

.tab__direction__vertical.tab__selected .tabLabel {
  box-shadow: inset 2px 0 0 var(--colors-primary-main);
}

.tab__direction__horizontal {
  box-shadow: 0px -1px inset var(--colors-grays-light);
  padding: 12px 24px;
  text-align: center;
}

.tab__direction__horizontal.tab__full {
  flex-grow: 1;
  flex-shrink: 0;
  max-width: none;
}

.tab__direction__horizontal.tab__disabled {
  opacity: var(--opacity-disabled-numberfield-input);
  pointer-events: none;
}

.tab__direction__horizontal.tab__selected {
  box-shadow: 0px -2px inset var(--colors-primary-main);
}
